<template>
  <div>
    <div class="outmain heighthv pad_20 bor_rad5 ba_f">
      <div class="ba_f mar_t20">
        <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('store.pricing.title') }}</span>
        </div>
      </div>
      </div>
      <el-form ref="form" :model="form" label-width="180px">
        <el-form-item :label="$t('store.pricing.deliveryFee')">
          <el-radio-group v-model="form.type">
            <el-radio label="1">{{ $t('store.pricing.fixedAmount') }}</el-radio>
            <!-- <el-radio label="2">{{ $t('store.pricing.byDistance') }}</el-radio> -->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="" v-show="form.type == '1'">
          <div class="mar_t20">
            <el-input
              :placeholder="$t('store.pricing.amountPh')"
              v-model="form.money"
              type="number"
            >
              <template slot="prepend">{{ $t('store.pricing.perOrder') }}</template>
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item label="" v-show="form.type == '2'">
          <div>
            <el-form-item :label="$t('store.pricing.pathCalcMethod')">
              <el-radio-group v-model="form.pathCalc">
                <el-radio label="1">{{ $t('store.pricing.straightDistance') }}</el-radio>
                <el-radio label="2">{{ $t('store.pricing.cyclingDistance') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div>
            <el-form-item :label="$t('store.pricing.billingAdjust')">
              <el-radio-group v-model="form.adjust">
                <el-radio label="1">{{ $t('store.pricing.default') }}</el-radio>
                <el-radio label="2">{{ $t('store.pricing.roundUp') }}</el-radio>
                <el-radio label="3">{{ $t('store.pricing.roundDown') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div class="mar_t20">
            <el-input
              :placeholder="$t('store.pricing.startPricePh')"
              v-model="form.distanceStartMoney"
              type="number"
            >
              <template slot="prepend">{{ $t('store.pricing.startPrice') }}</template>
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>
            <el-input
              :placeholder="$t('store.pricing.kmPh')"
              v-model="form.startDistance"
              type="number"
            >
              <template slot="append">{{ $t('store.pricing.kmPerAddOne') }}</template>
            </el-input>
            <el-input
              :placeholder="$t('store.pricing.amountPh')"
              v-model="form.overstepMoney"
              type="number"
            >
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>
          </div>
          <div class="mar_t20">
            <el-input
              :placeholder="$t('store.pricing.kmPh')"
              v-model="form.overstepDistance"
              type="number"
            >
              <template slot="prepend">{{ $t('store.pricing.exceed') }}</template>
              <template slot="append">{{ $t('store.pricing.afterKmPerAdd') }}</template>
            </el-input>
            <el-input
              :placeholder="$t('store.pricing.amountPh')"
              v-model="form.overstepDistanceMoney"
              type="number"
            >
              <template slot="append">{{ $t('store.pricing.maxCharge') }}</template>
            </el-input>
            <el-input
              :placeholder="$t('store.pricing.amountPh')"
              v-model="form.maxMoney"
              type="number"
            >
              <template slot="append">{{ $t('common.yuan') }}</template>
            </el-input>
            <div class="yb_margin">
              {{ $t('store.pricing.billingRuleTip') }}
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { priceRule,priceRuleInfo } from "@/api/store";
export default {
   name:'valuerule',
  data() {
   
    return {
        id:'',
      form: {
        // exceedTime: '',
        type: "1",
        range: "",
        calculationType: "",
        pathCalc: '1',
        adjust: "1",
        startMoney: "",
        // fullMoney: '',
        distanceStartMoney: "",
        startDistance: "",
        overstepMoney: "",
        overstepDistance: "",
        overstepDistanceMoney: "",
        maxMoney: "",
        fixedStartMoney: "",
        fixedFullMoney: "",
        money: "",
        timeArr: [],
        weather: "",
        serviceMoney: "",
      },
      options: [
        {
          value: "0",
          label: "晴",
        },
        {
          value: "1",
          label: "阴天",
        },
        {
          value: "2",
          label: "下雨天",
        },
        {
          value: "3",
          label: "特殊天气",
        },
      ],
      value: "",
      list: [],
      // listLoading: true,
      selectRows: "",
      
      page: {
        total: 0,
        size: 10,
        currentPage: 1,
      },
    };
  },
  created() {
    if (this.$route.query.id) {
            this.id = this.$route.query.id
            // this.edit()
        }
    this.initData();
  },
  methods: {
    async initData() {
      const { data } = await priceRuleInfo({ id:this.id });
      this.form2 = this.form;
      this.form = Object.assign(this.form2, data);
      if (data.type == "3") {
        for (let i = 0; i < data.areaArr.length; i++) {
          data.areaArr[i].circle = "";
        }
        if (data.areaArr) {
          this.areaArr = data.areaArr.map((v) => ({
            shape: v.shape,
            money: v.money,
            startMoney: v.startMoney,
            // fullMoney: v.fullMoney,
            lng: v.lng,
            lat: v.lat,
            circle: v.circle,
            radius: +v.radius,
            selected: v.selected,
            color: v.color,
            details: v.details,
            timeArr: v.timeArr,
          }));
        }
        setTimeout(() => {
          this.init();
        }, 0);
      }
    },
    onSearch() {},
    setSelectRows(val) {
      this.selectRows = val;
    },
    addtimeInterval1() {
      let specObj = { startTime: "00:00", endTime: "00:00", money: "" };
      this.$set(this.form.timeArr, this.form.timeArr.length, specObj);
    },
    deltimeInterval1(index) {
      this.$delete(this.form.timeArr, index);
    },
    submitForm() {
      console.log(this.areaArr);
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
 
          // this.form.ident = "valuation";
          if (this.form.type == "3") {
            var areaArr = [];
            for (var i = 0, l = this.areaArr.length; i < l; i++) {
              if (this.areaArr[i].shape == 1) {
                //圆形
                areaArr.push({
                  shape: 1,
                  color: this.areaArr[i].color,
                  lat: this.areaArr[i].circle.center.lat,
                  lng: this.areaArr[i].circle.center.lng,
                  radius: this.areaArr[i].radius,
                  money: this.areaArr[i].money,
                  startMoney: this.areaArr[i].startMoney,
                  // fullMoney: this.areaArr[i].fullMoney,
                  selected: this.areaArr[i].selected,
                  timeArr: this.areaArr[i].timeArr,
                });
              } else {
                var details = [];
                for (
                  var k = 0, j = this.areaArr[i].details.path.elems.length;
                  k < j;
                  k++
                ) {
                  details.push({
                    lat: this.areaArr[i].details.path.elems[k].lat,
                    lng: this.areaArr[i].details.path.elems[k].lng,
                  });
                }
                areaArr.push({
                  shape: 2,
                  details: details,
                  radius: 0,
                  money: this.areaArr[i].money,
                  startMoney: this.areaArr[i].startMoney,
                  // fullMoney: this.areaArr[i].fullMoney,
                  color: this.areaArr[i].color,
                  selected: this.areaArr[i].selected,
                  timeArr: this.areaArr[i].timeArr,
                });
              }
            }
            this.form.rule = areaArr;
          }
          const { msg } = await priceRule({id:this.id,rule:this.form});
          this.$baseMessage(msg, "success");
          this.$router.push({name:'storelist'});
          // this.initData();
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss">
.el-form-item__content {
  text-align: left;
}
.tsinput .el-input {
  width: 300px !important;
}
</style>
